// KIEDYŚ/DZIŚ deep-link selection logic — pure, unit-tested (kiedys.test.mjs).
// Doctrine: a ?kiedys=YYYY param may only select a Skorowidze-confirmed,
// WMS-renderable year for THIS parcel. Anything else fails honestly with a
// notice and falls back to the default (newest confirmed) year — never a
// silent substitution.

/**
 * @param {Array} periods - availability periods for the parcel (may be empty).
 * @param {string|null} raw - raw ?kiedys= query value (may be null).
 * @returns {{year: number|null, notice: {code: string, year: number}|null}}
 */
export function pickInitialYear(periods, raw) {
  const renderable = (periods || []).filter((p) => p.render === "WMS_TIME");
  const fallback = renderable.length ? renderable[renderable.length - 1].year : null;
  if (!raw) return { year: fallback, notice: null };
  if (!/^\d{4}$/.test(raw)) return { year: fallback, notice: null }; // malformed = absent
  const y = parseInt(raw, 10);
  const hit = (periods || []).find((p) => p.year === y);
  if (hit && hit.render === "WMS_TIME") return { year: y, notice: null };
  if (hit) return { year: fallback, notice: { code: "DOWNLOAD_ONLY", year: y } };
  return { year: fallback, notice: { code: "NOT_CONFIRMED", year: y } };
}
